import { Component, OnInit } from '@angular/core';
import { PlatformLocation } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-generic',
  templateUrl: './generic.component.html',
  styleUrls: ['./generic.component.css']
})
export class GenericComponent implements OnInit {
  private availableOffers: any = [];
  public merchantsetup: any = {};
  private baseURL: any = ''; private fullURL: any = ''; public pageheading = "";

  constructor(platformLocation: PlatformLocation) {
    // this.baseURL = (platformLocation as any).location.origin;
    // this.merchantsetup = this.flightService.getMerchantData();
    // this.fullURL = (platformLocation as any).location.pathname;
  }

  ngOnInit() {

    // this.merchantsetup = this.flightService.getMerchantData();

    // this.getAvailableOffers();


  }

  // getAvailableOffers() {
  //   this.flightService.addpagecontent("", this.fullURL.substring(1), "", 'Get', 'pagecontent').subscribe(
  //     data => {
  //       var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
  //       if (resp.status == "Success") {
  //         this.availableOffers = resp.template;
  //         $("#generic").html(this.availableOffers[0].HTMLtxt);
  //       }
  //     }
  //   )
  // }
}
